var _construct = require("/opt/build/repo/node_modules/@babel/runtime/helpers/construct.js");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");

require("core-js/modules/es.array.flat.js");

require("core-js/modules/es.array.unscopables.flat.js");

/*! Leaflet.SmoothGeodesic 1.0.0 - created by Hunter Evanoff - https://github.com/hunter547/Leaflet.SmoothGeodesic */
var t = Math.PI / 180,
    s = 180 / Math.PI;

var i = /*#__PURE__*/function () {
  "use strict";

  function i(s, _i) {
    _classCallCheck(this, i);

    this.lat = s, this.lon = _i, this.x = t * _i, this.y = t * s;
  }

  _createClass(i, [{
    key: "view",
    value: function view() {
      return String(this.lon).slice(0, 4) + "," + String(this.lat).slice(0, 4);
    }
  }, {
    key: "antipode",
    value: function antipode() {
      var t = -1 * this.lat,
          s = this.lon < 0 ? 180 + this.lon : -1 * (180 - this.lon);
      return new i(s, t);
    }
  }]);

  return i;
}();

var o = /*#__PURE__*/function () {
  "use strict";

  function o() {
    _classCallCheck(this, o);

    this.coords = [], this.length = 0;
  }

  _createClass(o, [{
    key: "moveTo",
    value: function moveTo(t) {
      this.length++, this.coords.push(t);
    }
  }]);

  return o;
}();

var e = /*#__PURE__*/_createClass(function e(t) {
  "use strict";

  _classCallCheck(this, e);

  this.properties = t || {}, this.geometries = [];
});

var n = /*#__PURE__*/function () {
  "use strict";

  function n(t, s, o) {
    _classCallCheck(this, n);

    if (!t || void 0 === t[0] || void 0 === t[1]) throw new Error("GreatCircle constructor expects two args: start and end objects with x and y properties");
    if (!s || void 0 === s[0] || void 0 === s[1]) throw new Error("GreatCircle constructor expects two args: start and end objects with x and y properties");
    this.start = new i(t[0], t[1]), this.end = new i(s[0], s[1]), this.properties = o || {};

    var e = this.start.x - this.end.x,
        _n = this.start.y - this.end.y,
        h = Math.pow(Math.sin(_n / 2), 2) + Math.cos(this.start.y) * Math.cos(this.end.y) * Math.pow(Math.sin(e / 2), 2);

    if (this.g = 2 * Math.asin(Math.sqrt(h)), this.g === Math.PI) throw new Error("it appears " + this.start.view() + " and " + this.end.view() + " are 'antipodal', e.g diametrically opposite, thus there is no single route but rather infinite");
    if (isNaN(this.g)) throw new Error("could not calculate great circle between " + t + " and " + s);
  }

  _createClass(n, [{
    key: "interpolate",
    value: function interpolate(t) {
      var i = Math.sin((1 - t) * this.g) / Math.sin(this.g),
          o = Math.sin(t * this.g) / Math.sin(this.g),
          e = i * Math.cos(this.start.y) * Math.cos(this.start.x) + o * Math.cos(this.end.y) * Math.cos(this.end.x),
          _n2 = i * Math.cos(this.start.y) * Math.sin(this.start.x) + o * Math.cos(this.end.y) * Math.sin(this.end.x),
          h = i * Math.sin(this.start.y) + o * Math.sin(this.end.y);

      return [s * Math.atan2(h, Math.sqrt(Math.pow(e, 2) + Math.pow(_n2, 2))), s * Math.atan2(_n2, e)];
    }
  }, {
    key: "Arc",
    value: function Arc(t, s) {
      var i = [];
      if (!t || t <= 2) i.push([this.start.lat, this.start.lon]), i.push([this.end.lat, this.end.lon]);else {
        var _s = 1 / (t - 1);

        for (var _o = 0; _o < t; ++_o) {
          var _t = _s * _o,
              _e = this.interpolate(_t);

          i.push(_e);
        }
      }

      var _n3 = !1,
          h = 0;

      var a = s && s.offset ? s.offset : 10,
          r = 180 - a,
          c = -180 + a,
          p = 360 - a;

      for (var _t2 = 1; _t2 < i.length; ++_t2) {
        var _s2 = i[_t2 - 1][1],
            _o2 = i[_t2][1],
            _e2 = Math.abs(_o2 - _s2);

        _e2 > p && (_o2 > r && _s2 < c || _s2 > r && _o2 < c) ? _n3 = !0 : _e2 > h && (h = _e2);
      }

      var l = [];

      if (_n3 && h < a) {
        var _t3 = [];
        l.push(_t3);

        for (var _s3 = 0; _s3 < i.length; ++_s3) {
          var _o3 = i[_s3][1];

          if (_s3 > 0 && Math.abs(_o3 - i[_s3 - 1][1]) > p) {
            var _e3 = i[_s3 - 1][1],
                _n5 = i[_s3 - 1][0],
                _h = i[_s3][1],
                _a = i[_s3][0];

            if (_e3 > -180 && _e3 < c && 180 === _h && _s3 + 1 < i.length && i[_s3 - 1][1] > -180 && i[_s3 - 1][1] < c) {
              _t3.push([i[_s3][0], -180]), _s3++, _t3.push([i[_s3][0], i[_s3][1]]);
              continue;
            }

            if (_e3 > r && _e3 < 180 && -180 === _h && _s3 + 1 < i.length && i[_s3 - 1][1] > r && i[_s3 - 1][1] < 180) {
              _t3.push([i[_s3][0], 180]), _s3++, _t3.push([i[_s3][0], i[_s3][1]]);
              continue;
            }

            if (_e3 < c && _h > r) {
              var _t4 = _e3;
              _e3 = _h, _h = _t4;
              var _s4 = _n5;
              _n5 = _a, _a = _s4;
            }

            if (_e3 > r && _h < c && (_h += 360), _e3 <= 180 && _h >= 180 && _e3 < _h) {
              var _o4 = (180 - _e3) / (_h - _e3),
                  _c = _o4 * _a + (1 - _o4) * _n5;

              _t3.push([_c, i[_s3 - 1][1] > r ? 180 : -180]), _t3 = [], _t3.push([_c, i[_s3 - 1][1] > r ? -180 : 180]), l.push(_t3);
            } else _t3 = [], l.push(_t3);

            _t3.push([i[_s3][0], _o3]);
          } else _t3.push([i[_s3][0], i[_s3][1]]);
        }
      } else {
        var _t5 = [];
        l.push(_t5);

        for (var _s5 = 0; _s5 < i.length; ++_s5) {
          _t5.push([i[_s5][0], i[_s5][1]]);
        }
      }

      var u = new e(this.properties);

      for (var _t6 = 0; _t6 < l.length; ++_t6) {
        var _s6 = new o();

        u.geometries.push(_s6);
        var _i2 = l[_t6];

        for (var _t7 = 0; _t7 < _i2.length; ++_t7) {
          _s6.moveTo(_i2[_t7]);
        }
      }

      return u;
    }
  }]);

  return n;
}();

var h = null === window || void 0 === window ? void 0 : window.L;
h.SmoothGeodesic = h.Path.extend({
  options: {},
  initialize: function initialize(t, s, i, o) {
    h.setOptions(this, o), this._coords = this._generateCoordinates(t, s, i), this._setPath(this._catmullRom2bezier());
  },
  _generateCoordinates: function _generateCoordinates(t, s, i) {
    var o = new n(t instanceof h.LatLng ? [t.lat, t.lng] : t, s instanceof h.LatLng ? [s.lat, s.lng] : s),
        _o$Arc = o.Arc(i),
        e = _o$Arc.geometries;

    return e[0].coords;
  },
  _catmullRom2bezier: function _catmullRom2bezier() {
    var t = ["M", this._coords[0]],
        s = this._coords.flat();

    for (var _i3 = 0, _o5 = s.length; _o5 - 2 > _i3; _i3 += 2) {
      var _e4 = [];
      0 === _i3 ? (_e4.push({
        x: s[_i3],
        y: s[_i3 + 1]
      }), _e4.push({
        x: s[_i3],
        y: s[_i3 + 1]
      }), _e4.push({
        x: s[_i3 + 2],
        y: s[_i3 + 3]
      }), _e4.push({
        x: s[_i3 + 4],
        y: s[_i3 + 5]
      })) : _o5 - 4 === _i3 ? (_e4.push({
        x: s[_i3 - 2],
        y: s[_i3 - 1]
      }), _e4.push({
        x: s[_i3],
        y: s[_i3 + 1]
      }), _e4.push({
        x: s[_i3 + 2],
        y: s[_i3 + 3]
      }), _e4.push({
        x: s[_i3 + 2],
        y: s[_i3 + 3]
      })) : (_e4.push({
        x: s[_i3 - 2],
        y: s[_i3 - 1]
      }), _e4.push({
        x: s[_i3],
        y: s[_i3 + 1]
      }), _e4.push({
        x: s[_i3 + 2],
        y: s[_i3 + 3]
      }), _e4.push({
        x: s[_i3 + 4],
        y: s[_i3 + 5]
      }));
      var _n6 = [];
      _n6.push({
        x: _e4[1].x,
        y: _e4[1].y
      }), _n6.push({
        x: (-_e4[0].x + 6 * _e4[1].x + _e4[2].x) / 6,
        y: (-_e4[0].y + 6 * _e4[1].y + _e4[2].y) / 6
      }), _n6.push({
        x: (_e4[1].x + 6 * _e4[2].x - _e4[3].x) / 6,
        y: (_e4[1].y + 6 * _e4[2].y - _e4[3].y) / 6
      }), _n6.push({
        x: _e4[2].x,
        y: _e4[2].y
      }), t.push("C", [_n6[1].x, _n6[1].y], [_n6[2].x, _n6[2].y], [_n6[3].x, _n6[3].y]);
    }

    return t;
  },
  _setPath: function _setPath(t) {
    this._pathData = t, this._bounds = this._computeBounds();
  },
  _isSmoothGeodesicSVGCommand: function _isSmoothGeodesicSVGCommand(t) {
    return -1 !== ["M", "L", "H", "V", "C", "S", "Q", "T", "Z"].indexOf(t);
  },
  _computeBounds: function _computeBounds() {
    var t = h.latLngBounds([]);
    var s,
        i = "M";

    for (var _o6 = 0; _o6 < this._pathData.length; _o6++) {
      if (s = this._pathData[_o6], this._isSmoothGeodesicSVGCommand(s)) i = s;else if ("C" === i) {
        var _i4 = h.latLng(s[0], s[1]);

        s = this._pathData[++_o6];

        var _e5 = h.latLng(s[0], s[1]);

        s = this._pathData[++_o6];

        var _n7 = h.latLng(s[0], s[1]);

        t.extend(_i4), t.extend(_e5), t.extend(_n7), _n7.controlPoint1 = _i4, _n7.controlPoint2 = _e5;
      } else t.extend(s);
    }

    return t;
  },
  getCenter: function getCenter() {
    return this._bounds.getCenter();
  },
  _update: function _update() {
    this._map && this._updateCurveSvg();
  },
  _project: function _project() {
    var t,
        s = [0, 0],
        i = "M",
        o = h.point(0, 0);
    var e = this._map;
    this._points = [];

    for (var _n8 = 0; _n8 < this._pathData.length; _n8++) {
      if (t = this._pathData[_n8], this._isSmoothGeodesicSVGCommand(t)) this._points.push(t), i = t;else {
        switch (t.length) {
          case 2:
            o = e.project(h.latLng(t[0], t[1])).subtract(e.getPixelOrigin()), s = t;
            break;

          case 1:
            if ("H" === i) {
              o = e.project(h.latLng(s[0], t[0])).subtract(e.getPixelOrigin()), s = [s[0], t[0]];
            } else {
              o = e.project(h.latLng(t[0], s[1])).subtract(e.getPixelOrigin()), s = [t[0], s[1]];
            }

        }

        this._points.push(o);
      }
    }
  },
  _curvePointsToPath: function _curvePointsToPath(t) {
    var s,
        i = "M",
        o = "";

    for (var _e6 = 0; _e6 < t.length; _e6++) {
      if (s = t[_e6], "string" == typeof s && this._isSmoothGeodesicSVGCommand(s)) i = s, o += i;else switch (i) {
        case "H":
          o += s.x + " ";
          break;

        case "V":
          o += s.y + " ";
          break;

        default:
          o += s.x + "," + s.y + " ";
      }
    }

    return o || "M0 0";
  },
  beforeAdd: function beforeAdd(t) {
    var s;
    null === (s = h.Path.prototype.beforeAdd) || void 0 === s || s.call(this, t);
  },
  onAdd: function onAdd(t) {
    var s;
    h.Path.prototype.onAdd.call(this, t);
    var i = 1e3 * (this.options.fitBounds ? this.options.fitBounds.duration || .25 : 0);

    if (this.options.fitBounds && this._map.fitBounds(this._bounds, this.options.fitBounds), this.options.animate && this._path.animate) {
      var _t8 = this._svgSetDashArray();

      this.options.animate.delay && this._path.animate([{
        strokeDashoffset: _t8
      }, {
        strokeDashoffset: _t8
      }], {
        duration: this.options.animate.delay + i
      }), this._path.animate([{
        strokeDashoffset: _t8
      }, {
        strokeDashoffset: 0
      }], "number" == typeof this.options.animate ? this.options.animate + i : Object.assign(Object.assign({}, this.options.animate), {
        delay: (null === (s = this.options.animate) || void 0 === s ? void 0 : s.delay) || 0 + i
      }));
    }
  },
  _updateCurveSvg: function _updateCurveSvg() {
    this._renderer._setPath(this, this._curvePointsToPath(this._points)), this.options.animate && this._svgSetDashArray();
  },
  _svgSetDashArray: function _svgSetDashArray() {
    var t = this._path,
        s = t.getTotalLength();
    return this.options.dashArray || (t.style.strokeDasharray = s + " " + s), s;
  }
}), h.smoothGeodesic = function (t, s, i, o) {
  return new h.SmoothGeodesic(t, s, i, o || {});
}, void 0 !== window.L && (window.L.SmoothGeodesic = h.SmoothGeodesic, window.L.smoothGeodesic = function () {
  for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
    t[_key] = arguments[_key];
  }

  return _construct(h.SmoothGeodesic, t);
});